import { rest } from 'msw';
import { API_ROOT } from 'configs/env-vars';
import { deduSites } from '../mockData/dedu-data';

const DeduApi = [
  rest.get(`${API_ROOT}dedu-sites`, (req, res, ctx) => {
    const type = req.url.searchParams.get('type');
    const organizationId = req.url.searchParams.get('organizationId');
    if (type === 'LOAD_DEDU_SITES' && organizationId === 40) {
      return res(ctx.json(deduSites));
    }
    return res(ctx.json([]));
  }),
];
export default DeduApi;
